import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./helpers";
export class ImageService {
    constructor(http, helper) {
        this.http = http;
        this.helper = helper;
    }
    uploadImage(image, title) {
        const formData = new FormData();
        if (!title) {
            title = image.name;
        }
        formData.append('file', image);
        formData.append('title', title);
        formData.append('caption', title);
        return this.http.post(this.helper.getApiUrl('/media'), formData);
    }
}
ImageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImageService_Factory() { return new ImageService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.HelperService)); }, token: ImageService, providedIn: "root" });
